import dynamic from "next/dynamic"
import S from "./process.module.scss"
import SectionTitle from "../../components/section-title"

const ProcessAnimation = dynamic(() => import("./process/animation"), {
  ssr: false,
  loading: () => <div className={S.animationPlaceholder} />,
})

const ProcessGraph = () => {
  return (
    <section className="bg-gray u-section-padding-md">
      <div className="container">
        <SectionTitle className="text-center">
          Welcome to the
          <br className="d-sm-none" />
          <span className="d-none d-sm-inline">&nbsp;</span>
          Louvolite Trade Portal.
        </SectionTitle>
      </div>

      <div className={S.container}>
        <ProcessAnimation />
      </div>
    </section>
  )
}

export default ProcessGraph
